import React from 'react';
import { useNavigate } from 'react-router-dom';

interface GlassDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const MENU_SECTIONS = [
  {
    title: 'Diretório',
    items: [
      { label: 'Pousadas', path: '/pousadas', icon: 'cottage' },
      { label: 'Barcos-Hotéis', path: '/barcos-hoteis', icon: 'houseboat' },
      { label: 'Guias de Pesca', path: '/guias', icon: 'rowing' },
      { label: 'Pesqueiros', path: '/pesqueiros', icon: 'phishing' },
      { label: 'Turmas', path: '/turmas', icon: 'groups' },
      { label: 'Agências', path: '/agencias', icon: 'flight' },
    ]
  },
  {
    title: 'Nossa Pesca',
    items: [
      { label: 'Torneios', path: '/torneios', icon: 'emoji_events' },
      { label: 'Eventos', path: '/eventos', icon: 'event' },
      { label: 'Marketplace', path: '/marketplace', icon: 'storefront' },
      { label: 'Explorar', path: '/explorar', icon: 'explore' },
    ]
  },
  {
    title: 'Parceiros',
    items: [
      { label: 'Cadastrar Empresa', path: '/cadastrar-empresa', icon: 'add_business' },
      { label: 'Planos & Preços', path: '/planos', icon: 'price_check' },
    ]
  }
];

export const GlassDrawer: React.FC<GlassDrawerProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    onClose();
  };

  return (
    <>
      {/* Search Overlay Backdrop */}
      <div 
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] transition-opacity duration-500 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} 
        onClick={onClose}
      />

      {/* Drawer Content */}
      <div 
        className={`fixed inset-x-0 bottom-0 z-[70] bg-[#0F172A]/90 border-t border-white/10 rounded-t-[30px] shadow-[0_-10px_40px_rgba(0,0,0,0.5)] transition-transform duration-500 cubic-bezier(0.32, 0.72, 0, 1) ${isOpen ? 'translate-y-0' : 'translate-y-full'}`}
        style={{ maxHeight: '85vh' }}
      >
        {/* Handle Bar (Visual cue for dragging/swiping) */}
        <div className="w-full flex justify-center pt-4 pb-2" onClick={onClose}>
            <div className="w-12 h-1.5 bg-white/20 rounded-full" />
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(85vh-40px)] pb-12">
            
            {/* Header */}
            <div className="flex items-center justify-between mb-8">
                <h2 className="text-2xl font-bold font-display text-white tracking-tight">Menu</h2>
                <button 
                    onClick={onClose}
                    className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/70 hover:bg-white/10 hover:text-white transition-colors"
                >
                    <span className="material-symbols-outlined">close</span>
                </button>
            </div>

            {/* Sections */}
            <div className="space-y-8">
                {MENU_SECTIONS.map((section, idx) => (
                    <div key={idx}>
                        <h3 className="text-sm font-semibold text-white/40 uppercase tracking-wider mb-4 px-1">{section.title}</h3>
                        <div className="grid grid-cols-2 gap-3">
                            {section.items.map((item) => (
                                <button
                                    key={item.path}
                                    onClick={() => handleNavigation(item.path)}
                                    className="flex items-center gap-3 p-4 rounded-2xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-white/10 hover:scale-[1.02] active:scale-95 transition-all duration-200 text-left group"
                                >
                                    <div className="w-10 h-10 rounded-full bg-[#029DE1]/20 flex items-center justify-center text-[#029DE1] group-hover:bg-[#029DE1] group-hover:text-white transition-colors">
                                        <span className="material-symbols-outlined text-[20px]">{item.icon}</span>
                                    </div>
                                    <span className="font-medium text-gray-200 group-hover:text-white">{item.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* Version/Footer */}
            <div className="mt-12 text-center text-white/20 text-xs">
                <p>Nossa Pesca v2026.1.0 • Aeroglass Interface</p>
            </div>
        </div>
      </div>
    </>
  );
};
